import classNames from 'classnames';

interface Props {
  width?: number;
  color?: string;
  className?: string;
}

export default function Logo({ width = 145, color = 'text-brand-strong', className }: Props) {
  const ratio = 145 / 42;
  const height = Math.round(width / ratio);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 145 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames('fill-current', color, className)}
    >
      <path
        d="M19.6681 19.7636L17.3234 22.1196L14.9787 19.7636C13.6998 18.4785 13.6998 16.3561 14.9787 15.0709C15.5988 14.4479 16.432 14.0974 17.3234 14.0974C18.2148 14.0974 19.048 14.4479 19.6681 15.0709C20.2882 15.694 20.637 16.5313 20.637 17.427C20.637 18.3032 20.2882 19.1405 19.6681 19.7636ZM20.792 25.5856L23.1367 23.2295C26.334 20.0167 26.334 14.7789 23.1367 11.5661C21.5865 10.0084 19.5325 9.15161 17.3428 9.15161C15.1531 9.17108 13.0797 10.0278 11.5295 11.5855C8.33214 14.7983 8.33214 20.0362 11.5295 23.249L17.3234 29.0709L20.3269 32.089L23.7956 35.5744L27.2642 32.089L23.7956 28.6036L20.792 25.5856Z"
        fill="currentColor"
      />
      <path
        d="M17.3237 0C12.8862 0 8.44868 1.69402 5.05758 5.08206C1.80213 8.39221 0 12.7733 0 17.4075C0 22.0417 1.80213 26.4423 5.07696 29.733L17.2849 42L17.3237 41.9611L17.3624 42L20.7923 38.5535L17.3237 35.0876L8.52619 26.2476C6.18149 23.8915 4.88318 20.7371 4.88318 17.4075C4.88318 14.0779 6.18149 10.943 8.52619 8.56746C10.9484 6.11405 14.1264 4.88734 17.3237 4.88734C20.521 4.88734 23.6796 6.11405 26.1212 8.54798C28.4659 10.904 29.7642 14.0584 29.7642 17.388C29.7642 20.4061 28.679 23.2684 26.7412 25.5271L30.2292 29.032C33.0971 25.8387 34.6667 21.7302 34.6667 17.388C34.6667 12.7344 32.8646 8.35327 29.5898 5.06259C26.2181 1.71349 21.7612 0 17.3237 0Z"
        fill="currentColor"
      />
      <path
        d="M137.504 25.5077C134.578 25.5077 132.951 23.0153 132.951 20.0751C132.951 16.8234 134.617 14.6815 137.504 14.6815C140.43 14.6815 142.562 17.2323 142.562 20.0751C142.562 22.9179 140.411 25.5077 137.504 25.5077ZM137.776 13.0654C135.935 13.0654 134.268 13.8248 133.106 15.1488V13.3964H131.284V30.6481H133.144V24.7677C134.133 26.1697 135.78 27.1043 137.776 27.1043C141.729 27.1043 144.461 24.0278 144.461 20.0946C144.461 16.1419 141.729 13.0654 137.776 13.0654Z"
        fill="currentColor"
      />
      <path
        d="M121.284 25.5077C118.358 25.5077 116.731 23.0153 116.731 20.0751C116.731 16.8234 118.397 14.6815 121.284 14.6815C124.21 14.6815 126.342 17.2323 126.342 20.0751C126.342 22.9179 124.191 25.5077 121.284 25.5077ZM121.556 13.0654C119.715 13.0654 118.048 13.8248 116.886 15.1488V13.3964H115.045V30.6481H116.905V24.7677C117.893 26.1697 119.54 27.1043 121.536 27.1043C125.489 27.1043 128.222 24.0278 128.222 20.0946C128.241 16.1419 125.509 13.0654 121.556 13.0654Z"
        fill="currentColor"
      />
      <path
        d="M109.173 23.2879C108.418 24.4367 106.344 25.8387 104.174 25.8387C102.624 25.8387 101.384 25.0209 101.384 23.4437C101.384 20.7372 104.096 20.0362 109.173 20.0362V23.2879ZM105.375 13.1238C103.476 13.1238 101.577 13.8832 100.26 15.2657L101.577 16.2198C102.624 15.1878 104.058 14.6426 105.492 14.6426C107.294 14.6426 109.193 15.2657 109.193 17.4075V18.8484C105.976 18.8484 99.5039 18.4201 99.5039 23.5605C99.5039 25.7803 101.577 27.2601 103.67 27.2601C106.364 27.2601 107.953 26.1697 109.154 24.8651V26.9291H110.995V17.758C111.014 14.1753 108.534 13.1238 105.375 13.1238Z"
        fill="currentColor"
      />
      <path
        d="M97.7414 13.4159H93.6915L88.227 18.9263V7.61336H84.6808V26.968H88.227V23.1711L89.4671 22.0417L94.2341 26.968H98.6134L91.7343 19.5689L97.7414 13.4159Z"
        fill="currentColor"
      />
      <path
        d="M76.0184 19.3352V26.9291H79.5257V19.7441C79.5257 17.6022 80.7465 16.5508 82.4711 16.5508V13.4159C78.46 13.4159 76.0184 16.1224 76.0184 19.3352Z"
        fill="currentColor"
      />
      <path
        d="M70.0319 23.6189H66.6989C64.1798 23.6189 63.0559 21.9444 63.0559 20.2114C63.0559 18.4785 63.9667 16.6871 66.5052 16.6871C69.0436 16.6871 70.09 18.4785 70.0707 20.2114V23.6189H70.0319ZM66.5052 13.4159C62.2227 13.4159 59.4904 16.3755 59.4904 20.1725C59.4904 23.9499 62.1258 26.9875 66.4083 26.9875H73.578V20.153C73.6168 16.3561 70.7876 13.4159 66.5052 13.4159Z"
        fill="currentColor"
      />
      <path
        d="M50.5571 23.6579H47.1854V19.9388C47.1854 18.2058 48.2706 16.4145 50.7703 16.4145C53.2894 16.4145 54.2195 18.2837 54.2195 20.0167C54.2195 21.7497 53.0762 23.6579 50.5571 23.6579ZM50.7509 13.0848C46.4684 13.0848 43.6393 16.0445 43.6393 19.822V32.7316H47.2242V26.9485H50.8478C55.1303 26.9485 57.7656 23.7163 57.7656 19.9388C57.7656 16.1613 55.0528 13.0848 50.7509 13.0848Z"
        fill="currentColor"
      />
    </svg>
  );
}
// test
